import { render, staticRenderFns } from "./BannerBuit.vue?vue&type=template&id=ea77b836"
import script from "./BannerBuit.vue?vue&type=script&lang=js"
export * from "./BannerBuit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports